import { useState } from 'react';
import Cookies from 'js-cookie';
import { useLocation } from '@gatsbyjs/reach-router';

const CCPA_COOKIE_NAME = 'edx_do_not_sell';

const useCCPACookie = () => {
  const location = useLocation();
  const isOptOutEnabled = () => Cookies.get(CCPA_COOKIE_NAME) === 'true';
  const [sellPersonalData, setSellPersonalData] = useState(() => !isOptOutEnabled());

  const setOptOutEnabled = (enabled) => {
    const { host } = new URL(location?.href || process.env.GATSBY_SITE_DOMAIN);
    const hostParts = host.split('.');

    // Use global domain (`.edx.org`) without the subdomain
    const domain = hostParts.length > 2
      ? `.${hostParts.slice(-2).join('.')}`
      : host;

    const cookieOptions = process.env.GATSBY_COOKIE_ENV !== 'localhost'
      ? { domain, expires: 365 }
      : {};

    if (!enabled) {
      // If cookie is not set to true, then default to sharing the data
      Cookies.remove(CCPA_COOKIE_NAME, cookieOptions);
      return;
    }
    Cookies.set(CCPA_COOKIE_NAME, enabled, cookieOptions);
  };

  return {
    sellPersonalData, setSellPersonalData, isOptOutEnabled, setOptOutEnabled,
  };
};

export default useCCPACookie;
